<template lang="pug">
v-layout(row)
  v-snackbar(v-model="showSaveError" color="error")
    div {{ error }}
  v-snackbar(v-model="showSaveSuccess" color="success")
    div The fields map was saved successfully
  div
    v-btn.ml-0(color="primary" :loading="loading && newFieldsMap.name" :disabled="disableSaveFieldsMap" @click="openSaveDialog") Save Fields Map
  div
    v-autocomplete.selector(
      v-model="selectedMap"
      :items="data"
      :search-input.sync="toSearchValue"
      :loading="loading"
      label="Fields Maps"
      item-text="name"
      clearable
      dense
      return-object
    )
  liondesk-dialog(
    width="600px"
    v-model="showFieldsMapDialog"
    :disable-ok-button="!newFieldsMap.name"
    dialog-title="SAVE FIELDS MAP"
    ok-button-text="Save"
    @click:cancel="closeSaveDialog"
    @click:ok="handleSaveFieldsMap"
  )
    template(slot="body")
      v-container.px-0
        v-layout(row wrap)
          v-flex(xs12)
            v-text-field(label="Fields map name" v-model="newFieldsMap.name")
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import LiondeskDialog from '@/Core/components/LiondeskDialog';
import { debounce } from '@/Core/utilities';

export default {
  name: 'fieldsMaps',
  components: {
    LiondeskDialog,
  },
  props: {
    fieldsMap: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showFieldsMapDialog: false,
      newFieldsMap: {
        name: '',
      },
      selectedMap: null,
      toSearchValue: '',
    };
  },
  async created() {
    if (!this.data.length) {
      await this.findFieldsMaps({ page: 1, limit: 10, search: '' });
    }
  },
  watch: {
    toSearchValue(value) {
      if (value && value.length > 2) {
        debounce(this.findFieldsMaps, [{ page: 1, limit: 10, search: value }]);
        return;
      }

      debounce(this.findFieldsMaps, [{ page: 1, limit: 10, search: '' }]);
    },
    selectedMap: {
      handler(value) {
        this.$emit('change', value);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState('importContactsFieldsMaps', [
      'error',
      'loading',
      'data',
      'fieldsMapsTotal',
      'successSaved',
    ]),
    disableSaveFieldsMap() {
      if (!this.fieldsMap) return true;

      return !Object.keys(this.fieldsMap).length;
    },
    showSaveError: {
      get() {
        return !!this.error;
      },
      set(value) {
        this.clearMessages();
      },
    },
    showSaveSuccess: {
      get() {
        return this.successSaved;
      },
      set(value) {
        this.clearMessages();
      },
    },
  },
  methods: {
    ...mapActions('importContactsFieldsMaps', ['findFieldsMaps', 'saveFieldsMaps']),
    ...mapMutations('importContactsFieldsMaps', ['clearMessages']),
    openSaveDialog() {
      this.showFieldsMapDialog = true;
    },
    closeSaveDialog() {
      this.showFieldsMapDialog = false;
    },
    async handleSaveFieldsMap() {
      const payload = {
        name: this.newFieldsMap.name.trim(),
        map_fields: this.fieldsMap,
      };

      await this.saveFieldsMaps(payload);
      this.closeSaveDialog();

      await this.findFieldsMaps({ page: 1, limit: 10, search: '' });
      this.newFieldsMap.name = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.selector {
  margin-top: 0px;
  padding-top: 10px;
}
</style>
